module.exports = __webpack_public_path__ + "static/img/barcode.e71e7211.png";